import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './i18n/en.json';
import ptPT from './i18n/pt-PT.json';
import es from './i18n/es.json';

i18n.use(LanguageDetector).use(initReactI18next).init({
  fallbackLng: 'en',
  supportedLngs: ['en', 'pt-PT', 'es'],
  resources: {
    en: { translation: en },
    'pt-PT': { translation: ptPT },
    es: { translation: es },
  },
  interpolation: { escapeValue: false },
  detection: { order: ['querystring', 'localStorage', 'navigator'], lookupQuerystring: 'lang', caches: ['localStorage'] },
});

export default i18n;
